import React from 'react';

function Footer() {
  return (
    <footer className="bg-dark text-light">
      <div className="container">
          <div className="f-items default-padding">
              <div className="row">
                  <div className="single-item col-lg-4 col-md-6 item">
                      <div className="f-item about">
                          <h4 className="widget-title">About Us</h4>
                          <p>
                              Our service is underpinned by quality, value for money and an ability to cater for diverse staffing requirements, no matter how urgent.
                          </p>
                          
                          <div className="social">
                              <h5>Get Us:</h5>
                              <ul>
                                  <li className="facebook">
                                      <a href="#"><i className="fab fa-facebook-f"></i></a>
                                  </li>
                                  <li className="twitter">
                                      <a href="#"><i className="fab fa-twitter"></i></a>
                                  </li>
                                  <li className="youtube">
                                      <a href="#"><i className="fab fa-youtube"></i></a>
                                  </li>
                                  <li className="instagram">
                                      <a href="#"><i className="fab fa-instagram"></i></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>

                  <div className="single-item col-lg-2 col-md-6 item">
                      <div className="f-item link">
                          <h4 className="widget-title">Services</h4>
                          <ul>
                              <li>
                                  <a href="#">Nursing</a>
                              </li>
                              <li>
                                  <a href="#">Allied Health</a>
                              </li>
                              <li>
                                  <a href="#">Mental health/Rehab</a>
                              </li>
                              <li>
                                  <a href="#">Non-clinical healthcare</a>
                              </li>
                              <li>
                                  <a href="#">Orthopaedics</a>
                              </li>
                          </ul>
                      </div>
                  </div>

                  <div className="single-item col-lg-2 col-md-6 item">
                      <div className="f-item link">
                          <h4 className="widget-title">Useful Links</h4>
                          <ul>
                              <li>
                                  <a href="apply">Apply Here</a>
                              </li>
                              <li>
                                  <a href="contact">Contact Us</a>
                              </li>
                          </ul>
                      </div>
                  </div>

                  <div className="single-item col-lg-4 col-md-6 item">
                      <div className="f-item branches link">
                          <h4 className="widget-title">Our Headquarter</h4>
                          <div className="branches">
                              <ul>
                                  <li>
                                      <strong>Divine CHP Staffing:</strong>
                                      <span>
                                          <a href='https://maps.google.com/?q=101 Brady Court, Suite B, Cary, NC 27511'>
                                            101 Brady Court, Suite B, Cary, NC 27511
                                          </a>
                                          <br />
                                          Phone: <a href="tel:9199721964">919 972 1964</a>
                                          <br />
                                          Fax: 984 465 0694
                                      </span>
                                  </li>
                                 
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="footer-bottom">
          <div className="container">
              <div className="row align-center">
                  <div className="col-lg-6">
                      <p>Divine CHP Staffing 2022</p>
                  </div>
                  <div className="col-lg-6 text-right link">
                      <ul>
                          <li>
                              <a href="#">Terms</a>
                          </li>
                          <li>
                              <a href="#">Privacy</a>
                          </li>
                          <li>
                              <a href="#">Support</a>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </footer>
  );
}

export default Footer;